import styled from '@emotion/styled/macro';
import {BaseButton, forPhoneOnly, Spinner, Variables} from '@enter/core';
import { PageLayout } from 'components';

export const Wrapper = styled(PageLayout)`
    background-color: ${Variables.Colors.white};
    padding: 0;
    height: calc(100vh - ${Variables.topnavSize});

    ${forPhoneOnly(`
        height: calc(100vh - ${Variables.topnavSize});
    `)};
`;

export const Cell = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    flex-grow: 1;
    /* padding: 4px 0px; */
`;

export const Loader = styled(Spinner)`
    flex-grow: 0;
    margin-top: 40%;
`;

export const Expand = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    padding: 0;
`;



export const TitleWrapperRow = styled.div`
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

export const Title = styled.h1`
  margin: 0;
  height: 28px;
  font-family: Calibre;
  font-size: 28px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: 0.2px;
  padding-right: 8px;
  color: ${Variables.Colors.p500};
`;

export const MenuButton = styled(BaseButton)`
    display: none;
    display: inline-flex;
    margin: 12px 24px;
    padding: 0 8px;
    min-width: unset;
    cursor: pointer;
    z-index: 100;
    fill: ${Variables.Colors.ghostWhite};

    ${forPhoneOnly(`
        margin: 12px;
    `)};
`;